import { useHitMap } from '@/hooks/useHitMap'
import React from 'react'
import { useState, useEffect } from 'react'
import { BackButton } from '@/components/layout/NavBar'
import { Services } from '@/services/services'

import { CurrentSession } from '@/services/repository/session'
import { MainPageLayout } from '@/components/layout/MainLayout'
import { Translates } from '@/services/repository/i18n'
import { HitMapComponent } from '@/components/Map/HitMap'

import './MyHitMap.css'
import { HitMapNav, HitMapNavData, HitMapNavURLParams, hitsMap } from '../HitMap'
import { getTodayRange } from '@/common/time'

export const CommunalMyHitsMap = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const mid = useParams().mid
  const [navData, setNavData] = useState<HitMapNavData>({
    range: getTodayRange(),
    hitLvl: 'all',
    machinePoint: '',
    username: '',
    hitRange: hitsMap.all
  })

  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    if (session) {
      setTranslates(session.translates)
      return
    }
    services.i18n.get('main').then(setTranslates)
  }, [session])

  const { rows, error } = useHitMap(services, `/api/communal/my/hits/all?${HitMapNavURLParams(navData)}`)

  if (translates === undefined) {
    return <div className='spinner'></div>
  }

  return <MainPageLayout pageName='my-hitmap' services={services} translates={translates} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    
    <HitMapNav session={session} services={services} data={navData} setter={setNavData} fieldMatrix={{
      range: true,
      username: false,
      machineName: true
    }}/>

    <div className='default-map-container'>
      <HitMapComponent error={error} rows={rows} services={services} session={session} />
    </div>
  </MainPageLayout>
}
